<template>
  <v-container
    id="data-tables"
    tag="section"
    fluid
  >
    <base-material-card
      color="primary"
      icon="mdi-barcode-scan"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Variações de Preço Unitário
        </div>
      </template>

      <v-btn
        id="btn-nova-variacoes-preco-unitario"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push(`edit`)"
      >
        <v-icon
          left
          size="30px"
        >
          mdi-plus-circle
        </v-icon>
        NOVA VARIAÇÃO DE PREÇO
      </v-btn>

      <v-text-field
        id="variacoes-preco-unitario-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-variacoes-preco-unitario ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 265px"
      />

      <v-divider class="mt-10" />

      <v-data-table
        class="variacoes-preco-unitario-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        no-data-text="Nenhuma Variação de Preço Unitário disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :header-props="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-visualizar-variacoes-preco-unitario"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="(downloadProgressData[item.id] !== undefined) ? true : false"
            @click="$router.push(`visualizar/${item.id}`)"
          >
            <v-icon small>
              mdi-file-eye-outline
            </v-icon>
          </v-btn>
          <v-btn
            id="action-edit-variacoes-preco-unitario"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>
              mdi-pencil
            </v-icon>
          </v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-variacoes-preco-unitario"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="canRunItem(item)"
                @click="executarItem(item.id)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>
                    mdi-play
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title> Executar </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="canDeleteItem(item)"
                @click="openDialogDelete(item.id, item.nome)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title> Deletar </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>
                    mdi-file-find-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title> Detalhes </v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadLogs(item.id)">
                <v-list-item-title>
                  <v-icon small>
                    mdi-file-download-outline
                  </v-icon>
                  Downlad Logs
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">
        <span style="word-break: break-word">Deletar Variação de Preço Unitário #{{ dialogDeleteData.id }}</span>
      </template>
      <template slot="body">
        Tem certeza que deseja deletar a Variação de Preço Unitário <strong>{{ dialogDeleteData.titulo }}</strong>?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes da Variação de Preço Unitário"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
    <div
      v-show="false"
      id="charts"
    />
  </v-container>
</template>

<script>

import VariacoesPrecoUnitarioService from '@/services/VariacoesPrecoUnitarioService.js';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

export default {
  name: 'VariacoesPrecoUnitarioDataTable',

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
  },

  mixins: [powerupsActionsMixins],

  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    powerupService: VariacoesPrecoUnitarioService,
    powerupEntityName: 'Variação de Preço Unitário',
    search: '',
    headers: [
      {
        text: '#',
        value: 'id'
      },
      {
        text: 'Nome',
        value: 'nome'
      },
      {
        text: 'Usuário',
        value: 'usuario'
      },
      {
        text: 'Executado',
        value: 'executed'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'Ações',
        value: 'actions',
        class: 'pl-4'
      }
    ],
    svgs: []
  }),

  methods: {
    downloadLogs (id) {
      const empresa = this.$store.getters.getEmpresa;
      VariacoesPrecoUnitarioService
        .downloadLogs({ id, empresa })
        .then(res => {
          this.$toast.success('Preparando seu arquivo de logs para download.', '', { position: 'topRight' });
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `logs-varicao-preco-unitario-${id}.log`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          console.log(error);
          this.$toast.error('Falha ao baixar arquivo resultado :: Arquivo não encontrado.', '', { position: 'topRight' });
        });
    },
    openDialogDelete (id, titulo) {
      this.dialogDeleteData = { id, titulo };
      this.dialogDelete = true;
    },
    openDialogDetalhes (simulacao) {
      this.dialogDetalhesData = [
        {
          parametro: 'NOME:',
          valor: simulacao.nome
        },
        {
          parametro: 'TUCS:',
          valor: simulacao.parametros.tucs.join(', ')
        },
        {
          parametro: 'VARIÁVEIS:',
          valor: simulacao.parametros.vars.join(', ')
        }
      ];

      this.dialogDetalhes = true;
    }
  }
};
</script>

<style>
@media screen and (min-width: 800px) {
  .variacoes-preco-unitario-table table tr td:nth-child(2) {
    max-width: 200px;
  }

  .variacoes-preco-unitario-table table tr td:nth-child(6),
  .variacoes-preco-unitario-table table tr td:nth-child(5) {
    white-space: nowrap !important;
  }
}

@media screen and (max-width: 480px) {
  .bs-variacoes-preco-unitario {
    width: 256.08px !important;
  }
}

.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}
</style>
